import { IExtraFontSettings, IFontIDWithFamily, IFontIDWithStyle } from '../style-font-model';
import { Observable } from 'rxjs';
import { FontWeightStyle } from 'lottie-json-helper/lib/types';

export interface IFont {
    id: string;
    name: string;
    imageUrl: string;
    italicUrl: string;
    regularUrl: string;
    configs: {
        weights: {
            light: boolean;
            medium: boolean;
            bold: boolean;
        };
    };
}

export interface IFontsConfigs {
    fonts: IFont[];
}
export interface IAvailableFont extends IExtraFontSettings {
    id: string;
    name: string;
    family: string;
    whiteThumbSrc: string;
    blackThumbSrc: string;
    availableStyles: { whiteThumbSrc: string; blackThumbSrc: string; weight: FontWeightStyle }[];
    fallbacks: {
        fontId: string;
        supportedLanguages: string[];
    }[];
}
export interface IOptionalStyleForFont {
    id: FontWeightStyle;
    name: string;
    value: number;
    whiteThumbSrc: string;
    blackThumbSrc: string;
    specialFontId: string; /// Used to combine both id and weight to get a unique font id in list
}
export interface IAvailableFontWithStyles extends IAvailableFont {
    optionalStyles: IOptionalStyleForFont[];
}

export const fontWeightOptions = new Map<FontWeightStyle, { name: string; value: number }>([
    [FontWeightStyle.LIGHT, { name: 'Light', value: 300 }],
    [FontWeightStyle.REGULAR, { name: 'Regular', value: 400 }],
    [FontWeightStyle.MEDIUM, { name: 'Medium', value: 500 }],
    [FontWeightStyle.SEMI_BOLD, { name: 'Semi-Bold', value: 600 }],
    [FontWeightStyle.BOLD, { name: 'Bold', value: 700 }],
    [FontWeightStyle.EXTRA_BOLD, { name: 'Extra-Bold', value: 800 }],
    [FontWeightStyle.BLACK, { name: 'Black', value: 900 }],
]);
const FONT_STYLE_PRIORITY: FontWeightStyle[] = [
    FontWeightStyle.LIGHT,
    FontWeightStyle.REGULAR,
    FontWeightStyle.MEDIUM,
    FontWeightStyle.SEMI_BOLD,
    FontWeightStyle.BOLD,
    FontWeightStyle.EXTRA_BOLD,
    FontWeightStyle.BLACK,
];
export function findClosestStyleWithFallback(
    desiredStyle: FontWeightStyle,
    availableStyles: FontWeightStyle[]
): FontWeightStyle | undefined {
    // return FontWeightStyle.LIGHT;
    const desiredIndex = FONT_STYLE_PRIORITY.indexOf(desiredStyle);
    if (desiredIndex === -1) return undefined;

    // 1. Check if exact style exists
    if (availableStyles.includes(desiredStyle)) return desiredStyle;

    // 2. Try lighter styles (downward)
    for (let i = desiredIndex - 1; i >= 0; i--) {
        if (availableStyles.includes(FONT_STYLE_PRIORITY[i])) {
            return FONT_STYLE_PRIORITY[i];
        }
    }

    // 3. Try heavier styles (upward)
    for (let i = desiredIndex + 1; i < FONT_STYLE_PRIORITY.length; i++) {
        if (availableStyles.includes(FONT_STYLE_PRIORITY[i])) {
            return FONT_STYLE_PRIORITY[i];
        }
    }

    // 4. Nothing found
    return undefined;
}
